module.exports = __webpack_public_path__ + "img/completed-file-approval-survey.de209dbc.png";